/* ==========================================================================
   YUNSO — Page produit
   Galerie, sélection de variante, packs, achat complémentaire, ajout panier
   et barre d'achat collante. Sans dépendance externe.
   ========================================================================== */

(function () {
  'use strict';

  function init(root) {
    var section = (root || document).querySelector('[data-product-section]');
    if (!section || section.dataset.bound === 'true') return;
    section.dataset.bound = 'true';

    var form = section.querySelector('form[action*="/cart/add"]');
    var cartUrl = section.dataset.cartUrl || '/cart';
    var afterAdd = section.dataset.afterAdd || 'cart';

    // Le format monétaire vient des réglages de la boutique, pas d'Intl :
    // sinon les prix calculés en JS (packs) ne ressemblent pas aux prix
    // rendus par Liquid (panier, fiche), qui utilisent le filtre money.
    var moneyFormat = section.dataset.moneyFormat || '{{amount_with_comma_separator}} €';

    function group(cents, precision, thousands, decimal) {
      if (isNaN(cents)) return '0';
      var parts = (cents / 100.0).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    function formatCents(cents) {
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;
      var match = moneyFormat.match(placeholder);
      if (!match) return moneyFormat;

      var value;
      switch (match[1]) {
        case 'amount': value = group(cents, 2, ',', '.'); break;
        case 'amount_no_decimals': value = group(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': value = group(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = group(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': value = group(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = group(cents, 0, ' ', ','); break;
        case 'amount_with_apostrophe_separator': value = group(cents, 2, "'", '.'); break;
        default: value = group(cents, 2, ',', '.');
      }
      return moneyFormat.replace(placeholder, value);
    }

    /* ------------------------------------------------------------ Galerie */

    var gallery = section.querySelector('[data-gallery]');
    var slidesEl = gallery && gallery.querySelector('[data-gallery-slides]');

    function initGallery() {
      if (!slidesEl) return;

      var slides = Array.prototype.slice.call(slidesEl.querySelectorAll('[data-gallery-slide]'));
      var thumbsEl = gallery.querySelector('[data-gallery-thumbs]');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      var current = 0;
      // Levé le temps d'un bouclage, pour que la bande de vignettes revienne
      // au début d'un coup elle aussi, et non en rembobinant.
      var jumping = false;

      function goTo(index, behavior) {
        if (index < 0 || index >= slides.length) return;
        slidesEl.scrollTo({
          left: slides[index].offsetLeft - slidesEl.offsetLeft,
          behavior: behavior || 'smooth'
        });
      }

      // La flèche de droite ne se bloque jamais : depuis le dernier visuel,
      // elle revient au premier. Ce retour-là se fait sans animation. Un
      // défilement lissé rembobinerait toute la bande, et syncVideos
      // lancerait puis couperait chaque vidéo traversée au passage.
      function goNext() {
        if (current === slides.length - 1) {
          jumping = true;
          goTo(0, 'auto');
        } else {
          goTo(current + 1);
        }
      }

      // Les vidéos tournent sans contrôles : seule celle qu'on regarde doit
      // jouer. Les autres restent en pause plutôt que de consommer de la
      // bande passante hors champ.
      function syncVideos(index) {
        slides.forEach(function (slide, i) {
          var video = slide.querySelector('video');
          if (!video) return;
          if (i === index) {
            var played = video.play();
            // Lecture refusée par le navigateur : on laisse l'affiche.
            if (played && played.catch) played.catch(function () {});
          } else {
            video.pause();
          }
        });
      }

      // La bande de vignettes déborde de l'écran dès quatre ou cinq visuels :
      // l'active y est recentrée pour rester sous les yeux, avec ses voisines
      // de part et d'autre. Le calcul passe par getBoundingClientRect plutôt
      // que par offsetLeft : la bande n'est pas positionnée, ses vignettes le
      // sont, et les offsetParent ne se correspondent donc pas. scrollBy
      // borne de lui-même aux deux extrémités, et ne bouge pas quand tout
      // tient déjà dans la largeur.
      function centerThumb(index, behavior) {
        var thumb = thumbs[index];
        if (!thumbsEl || !thumb) return;
        var strip = thumbsEl.getBoundingClientRect();
        var box = thumb.getBoundingClientRect();
        thumbsEl.scrollBy({
          left: box.left - strip.left - (strip.width - box.width) / 2,
          behavior: behavior
        });
      }

      function sync(index) {
        current = index;
        var behavior = jumping ? 'auto' : 'smooth';
        jumping = false;

        thumbs.forEach(function (thumb, i) {
          thumb.setAttribute('aria-current', String(i === index));
        });
        // Seule la flèche de gauche se retire, sur le premier visuel : il n'y
        // a rien avant lui. Celle de droite reste toujours cliquable.
        if (prev) prev.disabled = index === 0;
        centerThumb(index, behavior);
        syncVideos(index);
      }

      // La diapositive active est déduite de la position de défilement :
      // cela reste juste que la navigation vienne des flèches, des
      // vignettes ou d'un glissement au doigt.
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            sync(slides.indexOf(entry.target));
          });
        },
        { root: slidesEl, threshold: 0.55 }
      );

      slides.forEach(function (slide) { observer.observe(slide); });

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          goTo(parseInt(thumb.dataset.index, 10));
        });
      });

      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', goNext);

      slidesEl.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); goNext(); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(current - 1); }
      });

      sync(0);

      // Exposé pour que le changement de variante puisse cadrer son média.
      gallery.goToMediaId = function (mediaId) {
        var index = slides.findIndex(function (slide) {
          return slide.dataset.mediaId === String(mediaId);
        });
        if (index >= 0) goTo(index);
      };
    }

    /* --------------------------------------------------------- Variantes */

    var picker = section.querySelector('[data-variant-picker]');
    var variantIdInput = section.querySelector('[data-variant-id]');
    var variants = [];
    var currentVariant = null;

    if (picker) {
      var dataEl = picker.querySelector('[data-variant-data]');
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (error) {
        variants = [];
      }
    }

    function selectedOptions() {
      var values = [];
      picker.querySelectorAll('[data-option-input]:checked').forEach(function (input) {
        values[parseInt(input.dataset.optionPosition, 10)] = input.value;
      });
      picker.querySelectorAll('[data-option-select]').forEach(function (select) {
        values[parseInt(select.dataset.optionPosition, 10)] = select.value;
      });
      return values;
    }

    function findVariant(values) {
      return variants.find(function (variant) {
        return variant.options.every(function (option, i) {
          return option === values[i];
        });
      });
    }

    function updateVariant() {
      var values = selectedOptions();
      var variant = findVariant(values);
      currentVariant = variant || null;

      // Intitulé de l'option en cours, à côté du nom de l'option.
      picker.querySelectorAll('[data-option-value]').forEach(function (el) {
        var index = parseInt(el.dataset.optionValue, 10);
        if (values[index]) el.textContent = values[index];
      });

      var addButton = section.querySelector('[data-add-button]');
      var addLabel = section.querySelector('[data-add-label]');

      if (!variant) {
        if (variantIdInput) variantIdInput.value = '';
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = addLabel.dataset.unavailable || 'Indisponible';
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      if (addButton) addButton.disabled = !variant.available;
      if (addLabel && !variant.available) {
        addLabel.textContent = addLabel.dataset.soldOut || 'Rupture de stock';
      } else if (addLabel && addLabel.dataset.original) {
        addLabel.textContent = addLabel.dataset.original;
      }

      // Média associé à la variante
      if (variant.featured_media_id && gallery && gallery.goToMediaId) {
        gallery.goToMediaId(variant.featured_media_id);
      }

      updatePacks();
      updateSubscription();
      updatePrice();
      updateSticky();

      // L'URL suit la variante, pour que le lien soit partageable.
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    /* ------------------------------------------------------------- Packs */

    var packsEl = section.querySelector('[data-packs]');
    var quantityInput = section.querySelector('[data-quantity-input]');

    function currentUnitPrice() {
      if (currentVariant) return currentVariant.price;
      if (variants.length) return variants[0].price;
      // Produit à variante unique : aucun sélecteur n'est rendu, donc aucune
      // table de variantes. Sans ce repli, les packs s'afficheraient à zéro.
      var source = packsEl || section.querySelector('[data-subscription]');
      var fromLiquid = source && parseInt(source.dataset.unitPrice, 10);
      return fromLiquid || 0;
    }

    // Même arrondi que Shopify : à l'unité, vers le bas. La remise du pack
    // s'applique après celle de l'abonnement, sur le prix déjà réduit.
    function packTotal(price, qty) {
      var discount = packsEl ? parseInt(packsEl.dataset.discount, 10) || 0 : 0;
      var unitDiscount = qty > 1 ? Math.floor((price * discount) / 100) : 0;
      return (price - unitDiscount) * qty;
    }

    function selectedPackQty() {
      var checked = packsEl && packsEl.querySelector('[data-pack-input]:checked');
      var pack = checked && checked.closest('[data-pack]');
      return pack ? parseInt(pack.dataset.qty, 10) || 1 : 1;
    }

    function updatePacks() {
      if (!packsEl) return;

      var oneTime = currentUnitPrice();
      var subscribed = subscribedUnitPrice();
      var unit = subscribed !== null ? subscribed : oneTime;

      packsEl.querySelectorAll('[data-pack]').forEach(function (pack) {
        var qty = parseInt(pack.dataset.qty, 10) || 1;
        var before = oneTime * qty;
        var after = packTotal(unit, qty);

        var total = pack.querySelector('[data-pack-total]');
        var each = pack.querySelector('[data-pack-each]');
        var save = pack.querySelector('[data-pack-save]');
        var was = pack.querySelector('[data-pack-was]');

        if (total) total.textContent = formatCents(after);
        if (each) each.textContent = formatCents(Math.round(after / qty));
        // Signe moins typographique (U+2212), pas un trait d'union.
        if (save) save.textContent = '\u2212' + formatCents(before - after);

        // Abonné : le prix du même pack en achat unique, barré.
        if (was) {
          var showWas = subscribed !== null && subscribed < oneTime;
          was.hidden = !showWas;
          was.textContent = showWas ? formatCents(packTotal(oneTime, qty)) : '';
        }
      });
    }

    function syncQuantityFromPack() {
      if (!packsEl || !quantityInput) return;
      var checked = packsEl.querySelector('[data-pack-input]:checked');
      quantityInput.value = checked ? checked.value : '1';
    }

    /* -------------------------------------------------------- Abonnement */

    var subscriptionEl = section.querySelector('[data-subscription]');
    var subscriptionInput = subscriptionEl && subscriptionEl.querySelector('[data-subscription-input]');
    // { plan: { variante: prix abonné } }
    var subscriptionPrices = {};

    if (subscriptionEl) {
      try {
        subscriptionPrices = JSON.parse(subscriptionEl.querySelector('[data-subscription-prices]').textContent);
      } catch (error) {
        subscriptionPrices = {};
      }
    }

    function currentVariantId() {
      if (currentVariant) return String(currentVariant.id);
      return variantIdInput ? String(variantIdInput.value) : '';
    }

    function planPrice(planId) {
      var prices = subscriptionPrices[planId];
      var price = prices && prices[currentVariantId()];
      return typeof price === 'number' ? price : null;
    }

    function selectedPlanId() {
      if (!subscriptionEl) return null;
      var checked = subscriptionEl.querySelector('[data-plan-input]:checked');
      return checked ? checked.value : null;
    }

    // Prix abonné de la variante en cours, ou null si la case est décochée
    // ou si cette variante n'est pas proposée dans le plan choisi.
    function subscribedUnitPrice() {
      if (!subscriptionInput || !subscriptionInput.checked) return null;
      var planId = selectedPlanId();
      return planId ? planPrice(planId) : null;
    }

    function percentOff(unit, price) {
      return Math.round(((unit - price) / unit) * 100);
    }

    function updateSubscription() {
      if (!subscriptionEl) return;

      var unit = currentUnitPrice();
      var anyAvailable = false;

      // Une fréquence que la variante en cours ne propose pas est masquée.
      // Si c'était la fréquence choisie, on se replie sur la première dispo.
      var inputs = Array.prototype.slice.call(subscriptionEl.querySelectorAll('[data-plan-input]'));
      inputs.forEach(function (input) {
        var price = planPrice(input.value);
        var option = input.closest('.subscribe__plan');
        option.hidden = price === null;
        if (price === null) {
          if (input.checked) input.checked = false;
          return;
        }
        anyAvailable = true;
        var save = option.querySelector('[data-plan-save]');
        if (save && unit > 0) save.textContent = '\u2212' + percentOff(unit, price) + '\u00a0%';
      });

      if (!selectedPlanId()) {
        var first = inputs.find(function (input) { return !input.closest('.subscribe__plan').hidden; });
        if (first) first.checked = true;
      }

      // Variante sans aucun plan : la case disparaît et se décoche, pour ne
      // pas envoyer au panier un plan qu'elle ne porte pas.
      subscriptionEl.hidden = !anyAvailable;
      if (!anyAvailable) subscriptionInput.checked = false;

      // La remise annoncée dans le titre suit la fréquence choisie.
      var title = subscriptionEl.querySelector('[data-subscription-title]');
      var planId = selectedPlanId();
      var price = planId ? planPrice(planId) : null;
      if (title && price !== null && unit > 0) {
        title.textContent = title.dataset.template.replace('[percent]', percentOff(unit, price) + ' %');
      }
    }

    /* -------------------------------------------------------------- Prix */

    // Le bloc Prix affiche ce qui partira au panier : pack et abonnement
    // compris. Le prix barré est la plus haute référence disponible, pour la
    // même quantité : prix de comparaison de la variante, prix déduit de la
    // « réduction affichée » du bloc, ou simple prix d'achat unique.
    function updatePrice() {
      var priceBlock = section.querySelector('[data-price-block]');
      if (!priceBlock) return;

      var priceCurrent = priceBlock.querySelector('[data-price-current]');
      var priceCompare = priceBlock.querySelector('[data-price-compare]');
      var priceBadge = priceBlock.querySelector('[data-price-badge]');

      var oneTime = currentUnitPrice();
      if (!oneTime) return;
      var subscribed = subscribedUnitPrice();
      var qty = selectedPackQty();
      var paid = packTotal(subscribed !== null ? subscribed : oneTime, qty);

      var compareAt = currentVariant
        ? currentVariant.compare_at_price || 0
        : parseInt(priceBlock.dataset.compareAt, 10) || 0;
      var discount = parseFloat(priceBlock.dataset.displayDiscount) || 0;
      var fromDiscount = discount > 0 && discount < 100 ? Math.round((oneTime * 100) / (100 - discount)) : 0;
      var reference = Math.max(compareAt, fromDiscount, oneTime) * qty;

      var onSale = reference > paid;
      if (priceCurrent) priceCurrent.textContent = formatCents(paid);
      if (priceCompare) {
        priceCompare.textContent = onSale ? formatCents(reference) : '';
        priceCompare.hidden = !onSale;
      }
      if (priceBadge) {
        priceBadge.hidden = !onSale;
        // Signe moins typographique (U+2212), pas un trait d'union.
        if (onSale) priceBadge.textContent = '\u2212' + Math.round(((reference - paid) / reference) * 100) + '\u00a0%';
      }
    }

    /* ------------------------------- Compte à rebours d'expédition */

    // Jusqu'à l'heure limite du jour, heure de Paris. Une commande passée
    // avant part le jour ouvré suivant, que l'on nomme : « demain » ou
    // « lundi » quand le week-end s'intercale.
    var shipEl = section.querySelector('[data-ship-countdown]');

    function initShipCountdown() {
      if (!shipEl || !window.Intl) return;

      var timeEl = shipEl.querySelector('[data-ship-time]');
      var dayEl = shipEl.querySelector('[data-ship-day]');
      var cutoff = parseInt(shipEl.dataset.cutoff, 10) || 86400;
      var saturday = shipEl.dataset.saturday === 'true';
      var tomorrow = dayEl ? dayEl.textContent : '';
      var weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var names = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
      var paris = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Paris', hourCycle: 'h23',
        weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit'
      });

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function tick() {
        if (!shipEl.isConnected) return clearInterval(timer);

        var p = {};
        paris.formatToParts(new Date()).forEach(function (part) { p[part.type] = part.value; });
        var now = +p.hour * 3600 + +p.minute * 60 + +p.second;
        var orderDay = weekdays.indexOf(p.weekday);
        var daysAway = 0;

        // Heure limite passée : la commande compte pour le lendemain.
        var left = cutoff - now;
        if (left <= 0) {
          left += 86400;
          orderDay = (orderDay + 1) % 7;
          daysAway = 1;
        }

        var shipDay = orderDay;
        do {
          shipDay = (shipDay + 1) % 7;
          daysAway++;
        } while (shipDay === 0 || (shipDay === 6 && !saturday));

        if (timeEl) {
          timeEl.textContent = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor(left / 60) % 60) + ':' + pad(left % 60);
        }
        if (dayEl) dayEl.textContent = daysAway === 1 ? tomorrow : names[shipDay];
      }

      var timer = setInterval(tick, 1000);
      tick();
    }

    /* ------------------------------------- Barre collante : prix et libellé */

    // Prix et libellé de la barre : ceux de ce qui partira au panier, pack
    // et abonnement compris. À rappeler après tout changement de sélection.
    function updateSticky() {
      var stickyPrice = section.parentNode.querySelector('[data-sticky-price]');
      var stickyVariant = section.parentNode.querySelector('[data-sticky-variant]');

      var checkedPack = packsEl && packsEl.querySelector('[data-pack-input]:checked');
      var pack = checkedPack && checkedPack.closest('[data-pack]');
      var packQty = pack ? parseInt(pack.dataset.qty, 10) || 1 : 1;

      if (stickyPrice) {
        // Les totaux des packs sont déjà calculés par updatePacks().
        var packTotalEl = pack && pack.querySelector('[data-pack-total]');
        if (packTotalEl && packTotalEl.textContent.trim()) {
          stickyPrice.textContent = packTotalEl.textContent;
        } else {
          var unit = currentUnitPrice();
          var subscribed = subscribedUnitPrice();
          if (unit > 0) stickyPrice.textContent = formatCents(subscribed !== null ? subscribed : unit);
        }
      }

      if (stickyVariant) {
        if (!stickyVariant.dataset.base) stickyVariant.dataset.base = stickyVariant.textContent.trim();
        var parts = [currentVariant ? currentVariant.title : stickyVariant.dataset.base];
        var packName = pack && pack.querySelector('.pack__name');
        if (packQty > 1 && packName) parts.unshift(packName.textContent.trim());
        stickyVariant.textContent = parts.filter(Boolean).join(' · ');
      }
    }

    /* ------------------------------------------------ Ajout au panier */

    var addButton = section.querySelector('[data-add-button]');
    var addLabel = section.querySelector('[data-add-label]');
    var errorEl = section.querySelector('[data-buy-error]');
    var errorText = section.querySelector('[data-buy-error-text]');
    var addedEl = section.querySelector('[data-buy-added]');

    if (addLabel) addLabel.dataset.original = addLabel.textContent.trim();

    function setLoading(state) {
      section.querySelectorAll('[data-add-button], [data-sticky-add]').forEach(function (btn) {
        btn.dataset.loading = String(state);
      });
      var sticky = document.querySelector('[data-sticky-add]');
      if (sticky) sticky.dataset.loading = String(state);
    }

    function showError(message) {
      if (!errorEl) return;
      if (errorText) errorText.textContent = message;
      errorEl.dataset.visible = 'true';
      if (addedEl) addedEl.dataset.visible = 'false';
    }

    function clearMessages() {
      if (errorEl) errorEl.dataset.visible = 'false';
      if (addedEl) addedEl.dataset.visible = 'false';
    }

    function buildItems() {
      var items = [];
      var id = variantIdInput ? variantIdInput.value : null;
      var qty = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      if (!id) return null;
      var item = { id: Number(id), quantity: qty };
      // Le plan ne suit que le produit principal, jamais l'achat complémentaire.
      if (subscribedUnitPrice() !== null) item.selling_plan = Number(selectedPlanId());
      items.push(item);

      // Chaque case d'achat complémentaire cochée ajoute sa propre ligne.
      section.querySelectorAll('[data-upsell-input]:checked').forEach(function (input) {
        items.push({ id: Number(input.dataset.variantId), quantity: 1 });
      });

      return items;
    }

    // Suite normale d'un ajout : page panier, ou confirmation sur place.
    function finishAdd() {
      if (afterAdd === 'cart') {
        window.location.href = cartUrl;
        return;
      }
      if (addedEl) addedEl.dataset.visible = 'true';
    }

    /* --------------------------------------------- Pop-up d'upsell */

    var upsellPopup = section.querySelector('[data-upsell-popup]');

    // Ouvre le pop-up si l'offre a lieu d'être. Renvoie false sinon, et
    // l'ajout suit alors son cours normal.
    function openUpsellPopup(cart, quantity) {
      if (!upsellPopup || typeof upsellPopup.showModal !== 'function') return false;

      // Déjà au panier : rien à proposer.
      var offerId = Number(upsellPopup.dataset.variantId);
      var inCart = cart.items.some(function (item) { return item.variant_id === offerId; });
      if (inCart) return false;

      // Pack de 2 : la remise ne s'appliquerait pas (voir le bloc).
      var max = parseInt(upsellPopup.dataset.maxQuantity, 10);
      if (max && quantity > max) return false;

      upsellPopup.showModal();
      return true;
    }

    if (upsellPopup) {
      var popupAdd = upsellPopup.querySelector('[data-upsell-popup-add]');
      var popupError = upsellPopup.querySelector('[data-upsell-popup-error]');

      function leavePopup() {
        upsellPopup.close();
        finishAdd();
      }

      upsellPopup.querySelectorAll('[data-upsell-popup-skip]').forEach(function (button) {
        button.addEventListener('click', leavePopup);
      });

      // Échap ferme le dialogue nativement : on enchaîne alors sur la suite
      // normale, comme avec « Non merci ».
      upsellPopup.addEventListener('cancel', function (event) {
        event.preventDefault();
        leavePopup();
      });

      // Un clic sur le fond assombri vaut un refus.
      upsellPopup.addEventListener('click', function (event) {
        if (event.target === upsellPopup) leavePopup();
      });

      popupAdd.addEventListener('click', function () {
        popupAdd.dataset.loading = 'true';
        popupAdd.disabled = true;
        popupError.hidden = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(upsellPopup.dataset.variantId), quantity: 1 }] })
        })
          .then(function (response) {
            return response.json().then(function (body) {
              if (!response.ok) throw new Error(body.description || body.message || 'Ajout impossible.');
              return body;
            });
          })
          .then(function () {
            return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            if (window.Yunso && window.Yunso.updateCartCount) window.Yunso.updateCartCount(cart.item_count);
            upsellPopup.close();
            finishAdd();
          })
          .catch(function (error) {
            popupAdd.dataset.loading = 'false';
            popupAdd.disabled = false;
            popupError.textContent = error.message || 'Ajout impossible pour le moment.';
            popupError.hidden = false;
          });
      });
    }

    function handleSubmit(event) {
      if (!form) return;
      event.preventDefault();
      clearMessages();

      var items = buildItems();
      if (!items) {
        showError('Choisissez une finition avant d’ajouter au panier.');
        return;
      }

      setLoading(true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) throw new Error(body.description || body.message || 'Ajout impossible.');
            return body;
          });
        })
        .then(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          if (window.Yunso && window.Yunso.updateCartCount) {
            window.Yunso.updateCartCount(cart.item_count);
          }

          setLoading(false);
          if (openUpsellPopup(cart, items[0].quantity)) return;
          finishAdd();
        })
        .catch(function (error) {
          setLoading(false);
          showError(error.message || 'Ajout impossible pour le moment.');
        });
    }

    /* ------------------------------------------------- Barre collante */

    function initStickyBar() {
      var bar = document.querySelector('[data-sticky-buy]');
      if (!bar || !addButton) return;

      new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          // La barre n'apparaît qu'une fois le bouton principal dépassé,
          // jamais avant que l'utilisateur ne l'ait vu.
          var scrolledPast = entry.boundingClientRect.top < 0;
          bar.dataset.visible = String(!entry.isIntersecting && scrolledPast);
        },
        { threshold: 0, rootMargin: '0px 0px -40px 0px' }
      ).observe(addButton);

      // La barre recouvre le bas du pied de page, qui devient inatteignable.
      // On publie sa hauteur — encoche du téléphone comprise, elle est dans
      // son padding — pour que la feuille de style rende cette place au
      // pied de page. Sa hauteur dépend du texte, qui se replie selon la
      // largeur : on la suit plutôt que de la figer.
      function publishHeight() {
        document.documentElement.style.setProperty('--sticky-buy-h', bar.offsetHeight + 'px');
      }

      publishHeight();

      if (window.ResizeObserver) new ResizeObserver(publishHeight).observe(bar);
      else window.addEventListener('resize', publishHeight);
    }

    /* --------------------------------------------------------- Écoutes */

    initGallery();

    if (picker) {
      picker.addEventListener('change', function (event) {
        if (event.target.matches('[data-option-input], [data-option-select]')) updateVariant();
      });
      updateVariant();
    }

    if (packsEl) {
      packsEl.addEventListener('change', function () {
        syncQuantityFromPack();
        updatePrice();
        updateSticky();
        clearMessages();
      });
      syncQuantityFromPack();
      updatePacks();
    }

    if (subscriptionEl) {
      // Case et fréquences : un seul écouteur sur le bloc.
      subscriptionEl.addEventListener('change', function () {
        updateSubscription();
        updatePacks();
        updatePrice();
        updateSticky();
        clearMessages();
      });
      updateSubscription();
    }

    updatePrice();
    initShipCountdown();
    updateSticky();

    if (form) form.addEventListener('submit', handleSubmit);

    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
